export default function ReceiptLayout({ order, items, transaction, branchName, branchAddress, cashier }) {
  const isPOS = !!order.referenceNumber

  const refNum        = isPOS ? order.referenceNumber : order.reference_number
  const createdAt     = isPOS ? order.createdAt       : new Date(order.created_at)
  const fulfillment   = isPOS ? order.fulfillmentType : order.fulfillment_type
  const subtotal      = isPOS ? order.subtotal        : order.subtotal
  const discount      = isPOS ? order.discount        : order.discount
  const discountCode  = isPOS ? order.discountCode    : null
  const total         = isPOS ? order.total           : order.final_amount
  const paymentMethod = isPOS ? order.paymentMethod   : transaction?.payment_method
  const txStatus      = !isPOS ? transaction?.status  : null
  const orderSource   = isPOS ? 'POS' : (order.order_source === 'pos' ? 'POS' : 'Mobile App')
  const rawReceiptNo  = isPOS ? order.receiptNumber : order.receipt_number
  const receiptNo     = rawReceiptNo
    ? (/^\d+$/.test(String(rawReceiptNo)) ? String(rawReceiptNo).padStart(6, '0') : String(rawReceiptNo))
    : '000001'
  const fulfillMap    = { dine_in: 'Dine-In', takeout: 'Takeout', pickup: 'Pickup', delivery: 'Delivery' }

  const totalQty = items.reduce((sum, item) =>
    sum + (isPOS ? (parseInt(item.qty, 10) || 0) : (parseInt(item.quantity, 10) || 0)), 0)

  const fmt = (v) => `P${parseFloat(v || 0).toFixed(2)}`

  const s = { // base styles
    wrap:    { fontFamily: '"Courier New", Courier, monospace', fontSize: 12, maxWidth: 320, margin: '0 auto', backgroundColor: '#fff', padding: '12px 16px' },
    center:  { textAlign: 'center' },
    left:    { textAlign: 'left' },
    bold:    { fontWeight: 'bold' },
    big:     { fontSize: 20, fontWeight: 'bold', letterSpacing: 1 },
    small:   { fontSize: 11 },
    divider: { borderTop: '1px dashed #999', margin: '5px 0' },
    row:     { display: 'flex', justifyContent: 'space-between', marginBottom: 1 },
    indent:  { paddingLeft: 10, fontSize: 11 },
  }

  const D = () => <div style={s.divider} />

  const Row = ({ label, value, bold }) => (
    <div style={{ ...s.row, fontWeight: bold ? 'bold' : 'normal' }}>
      <span>{label}</span><span>{value}</span>
    </div>
  )

  return (
    <div style={s.wrap}>

      {/* Store name */}
      <div style={{ ...s.center, marginBottom: 4 }}>
        <div style={s.big}>Coffee Gusto</div>
        {branchAddress && <div style={s.small}>{branchAddress}</div>}
      </div>

      <D />

      {/* Order info */}
      <div style={{ marginBottom: 4 }}>
        <div style={s.small}>Receipt #{receiptNo}</div>
        <div style={s.small}>#{refNum}</div>
            <div style={s.small}>
                {createdAt.toLocaleString('en-PH', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })}
            </div>
            <div style={s.small}>{orderSource}</div>
            {cashier && <div style={s.small}>Cashier: {cashier}</div>}
        <div style={s.small}>{fulfillMap[fulfillment] || fulfillment || ''}</div>
      </div>

      <D />

      {/* Reprint notice — only for TransactionPrinter (non-POS view) */}
      {!isPOS && (
        <>
          <div style={{ ...s.center, ...s.small, marginBottom: 4 }}>* REPRINT ONLY *</div>
          <D />
        </>
      )}

      {/* Items */}
      {items.map((item, i) => {
        const name      = isPOS ? item.name : item.menu_items?.name || 'Item'
        const qty       = isPOS ? (parseInt(item.qty, 10) || 0) : (parseInt(item.quantity, 10) || 0)
        const unitPrice = isPOS ? item.unitPrice : parseFloat(item.item_price || 0)
        const lineTotal = (unitPrice * qty).toFixed(2)
        const variants  = isPOS ? item.variants : item.order_item_variants?.map(v => v.item_variants?.variant_name)
        const modifiers = isPOS ? item.modifiers : item.order_item_modifiers?.map(m => m.item_modifiers?.modifier_name)

        return (
          <div key={i} style={{ marginBottom: 5 }}>
            <Row label={`${name}`} value={lineTotal} />
            <div style={s.indent}>@P{unitPrice.toFixed(2)} x {qty}</div>
            {variants?.length > 0 && <div style={s.indent}>{variants.join(', ')}</div>}
            {modifiers?.length > 0 && <div style={s.indent}>+{modifiers.join(', ')}</div>}
          </div>
        )
      })}

      <D />

      {/* Totals */}
      <Row label="Subtotal" value={fmt(subtotal)} />
      {parseFloat(discount || 0) > 0 && (
        <Row label={`Discount${discountCode ? ` (${discountCode})` : ''}`} value={`-${fmt(discount)}`} />
      )}
      <Row label="TOTAL" value={fmt(total)} bold />

      <D />

      <Row label="Total QTY" value={`${totalQty}`} />

      {/* Payment */}
      {paymentMethod && (
        <>
          <D />
          {{
              cash: 'Cash',
              gcash: 'GCash',
              card: 'Card',
              managers_pullout: "Manager's Pull-Out",
              marketing_pullout: 'Marketing Pull-Out',
          }[paymentMethod] || paymentMethod?.toUpperCase()}
          {/* {txStatus && <div style={{ marginBottom: 1 }}>Status:  {txStatus}</div>} */}
        </>
      )}

      <D />

      <div style={{ ...s.center, ...s.small, marginBottom: 2 }}>
        Thank you for visiting!
      </div>
      <div style={{ ...s.center, ...s.small }}>
        NOT VALID FOR CLAIM OF INPUT TAX
      </div>

    </div>
  )
}